import { BusinessIdeaFieldCategoryDto } from "@api/business-idea-field-category-dto";
import { InjectionKey, Ref } from "vue";

export default Symbol("BusinessIdea field categories") as InjectionKey<
	Ref<BusinessIdeaFieldCategoryDto[] | null>
>;
